import data from './data'
import methods from './methods'
import validations from './validations'
import mounted from './mounted'

export default {
  data,
  methods,
  validations,
  mounted,
  resourcePath: '/v1/auth/login'
}



// WEBPACK FOOTER //
// ./src/app/auth/login/dweller/resources/index.js